export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateurs"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechercher un utilisateur par nom ou email..."])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun utilisateur"])},
        "column_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Id"])},
        "column_email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "column_full_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
        "column_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rôle"])},
        "column_signed_up": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inscrit"])},
        "signed_up_yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oui"])},
        "signed_up_no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Users"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search a user by name or email..."])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No user"])},
        "column_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Id"])},
        "column_email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "column_full_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "column_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Role"])},
        "column_signed_up": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Signed up"])},
        "signed_up_yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes"])},
        "signed_up_no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No"])}
      }
    }
  })
}
